export default "__VITE_ASSET__09b40c4a__$_?nuxt_component=async&nuxt_component_name=SvgoFreeshibainu__"